import Request from "./request";

const DATA_MAP_SERVER = "https://id.datamap.io";
const GET_VIMEO_OEMBED_URL = "https://vimeo.com/api/oembed.json";

const ID_SERVER = "http://localhost:8000";

const getPaymentHeader = (jwt) => {
  return { Authorization: jwt, "Content-Type": "application/json" };
};

export const getProjectCodeData = (code) => {
  const url = `${DATA_MAP_SERVER}/api/project/${code}`;

  return Request.get({
    url,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getVimeoOembed = (videoURL, doNotTrack = true) => {
  const urlParams = new URLSearchParams({
    url: videoURL,
    dnt: doNotTrack,
  });

  const url = `${GET_VIMEO_OEMBED_URL}?${urlParams.toString()}`;

  return Request.get({ url });
};

export const getYoutubeEmbed = (videoLink) => {
  const url = new URL(videoLink);
  const urlParams = new URLSearchParams(url.search);
  const videoURL = urlParams.get("v");

  if (videoURL) {
    return `https://www.youtube-nocookie.com/embed/${videoURL}`;
  }

  return "";
};

export const getProjectSurveys = (jwt, projectCode) => {
  const url = `${ID_SERVER}/api/project/${projectCode}/surveys`;

  return Request.get({ url, headers: getPaymentHeader(jwt) });
};

export const postUserSurvey = (jwt, projectCode, data) => {
  const url = `${ID_SERVER}/api/project/${projectCode}/survey`;

  return Request.post({ url, data, headers: getPaymentHeader(jwt) });
};

export const getUserPersonalData = (jwt) => {
  const url = `${ID_SERVER}/api/user/data`;

  return Request.get({ url, headers: getPaymentHeader(jwt) });
};

export const updateUserPersonalData = (jwt, data) => {
  const url = `${ID_SERVER}/api/user/update`;

  return Request.post({ url, data, headers: getPaymentHeader(jwt) });
};

export const hasUserAnsweredOnAllRequiredQuestions = (jwt, code, surveyId) => {
  const url = `${ID_SERVER}/api/project/${code}/survey/${surveyId}/has-user-answered-on-required`;

  return Request.get({ url, headers: getPaymentHeader(jwt) });
};
